// Session helpers shared by the surfaces that list agenda sessions — the
// registration agenda modal (pages/registration/index.vue) and the breakout
// picker cards (pages/registration/components/lp-session-card.vue).

/**
 * CE hours as shown to attendees: exactly what the organizer entered, up to
 * two decimals, trailing zeros dropped — 2.25 -> "2.25", 1.5 -> "1.5", 3 -> "3".
 * Must match ConferenceLandingPageService::formatCeHours().
 */
export function formatCeHours(hours) {
  return Number(hours).toFixed(2).replace(/\.?0+$/, '');
}

/**
 * The presenter part of a session's meta line. Endpoints disagree on the
 * shape: the agenda projection sends a pre-joined `presenter` string, the
 * registration sessions endpoint sends a `presenters` array.
 */
function presenterLine(session) {
  if (session.presenter) return session.presenter;

  return (session.presenters || [])
    .map((presenter) => presenter.name)
    .filter(Boolean)
    .join(' · ');
}

/**
 * "presenters · CE hours · topic(s)" — the one-line summary under a session
 * title. The time is omitted; every host shows it in its own block header.
 *
 * `includeCe: false` drops the CE-hours part for hosts that already show it
 * as its own chip (the registration agenda modal's session-type/level/CE row).
 */
export function sessionMeta(session, { includeCe = true } = {}) {
  const parts = [];

  const presenters = presenterLine(session);
  if (presenters) parts.push(presenters);

  if (includeCe && session.ceHours > 0) parts.push(`${formatCeHours(session.ceHours)} CE`);

  (session.topics || []).forEach((topic) => {
    if (topic.title) parts.push(topic.title);
  });

  return parts.join(' · ');
}
